/**
 * Do some default changes to paypal buttons to make them more visually appealing
 *
 * @package Hersey
 */

(function($) {
    $(document).ready(function() {

        paypalForm = $("form[action^='https://www.paypal.com'][data-pretty!=false]");
        if ( paypalForm ) {
            // Replace the ugly paypal button
            submitButtonText = paypalForm.attr('data-submit-text');
            if ( !submitButtonText ) {
                submitButtonText = "Buy";
            }
            herseySubmitButton = "<input type=\"submit\" value=\""+submitButtonText+"\" />";
            paypalSubmitButton = paypalForm.find('input[name="submit"][type="image"]');
            paypalSubmitButton.before(herseySubmitButton);
            paypalSubmitButton.remove();

            // Make required fields required
            requiredFields = paypalForm.attr('data-required-fields');
            if ( requiredFields ) {
                requiredFields = requiredFields.split(',');
                for ( i = 0; i < requiredFields.length; i++ ) {
                    requiredField = requiredFields[i];
                    paypalForm.find('input[name="'+requiredField+'"]').attr('required', 'required');
                }
            }
        }

    }); // document.ready
})(jQuery);